import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  ProgressIndicator,
  ProgressIndicatorSkeleton,
  ProgressStep,
  Modal,
  Loading,
} from 'carbon-components-react';
import { Breadcrumb } from '../../../../../components';
import { getByDmService, pathDmService } from '../../../../../services/Api';
import { getStatusClipboardsIndex } from '../../../../../utils/modifiers';

import Detail from './Detail';
import {
  PENDENTE,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  DEVOLVIDO,
  CANCELADO,
} from '../../../../../config/StatusRequest';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      isUpdating: false,
      openMdStatus: false,
      cancelModal: false,
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({nivel});
    this.loadClipboards();

  }

  loadClipboards = async () => {
    const { match } = this.props;

    try {
      const data = await getByDmService('/Pedido/GetAssistente', match.params.id);
      this.setState({ data, isLoading: false });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null, /* error: e, */ isLoading: false });
    }
  };

  toggleUpdateModal = () => {
    this.setState(prevState => ({ openMdStatus: !prevState.openMdStatus }));
  };

  toogleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  updateOrderStatus = async () => {
    const { data } = this.state;
    const { match } = this.props;
    const { id } = match.params;
    const arrStatus = [PENDENTE.id, PREPARACAO.id, PRONTAENTREGA.id, ENTREGUE.id, DEVOLVIDO.id];

    const index = arrStatus.indexOf(data.status.id);
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${arrStatus[index + 1]}&retirouUniforme=&dataRetiradaUniforme=`;

    this.updateStatus(serviceUrl, index);
  };

  cancelRequest = () => {
    const { match } = this.props;
    const { id } = match.params;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${CANCELADO.id}&retirouUniforme=&dataRetiradaUniforme=`;
    this.updateStatus(serviceUrl, 4);
  };

  updateStatus = (serviceUrl, indexMsg) => {
    const messages = [
      'Status alterado para preparação',
      'Status alterado para Pronto p/ Entrega',
      'Status alterado para entregue',
      'Status alterado para Devolvido',
      'Pedido Cancelado conforme o solicitado.',
    ];

    pathDmService(serviceUrl, {})
      .then(() => {
        const { history } = this.props;
        toast.success(messages[indexMsg]);
        if (indexMsg < 4) {
          this.loadClipboards();
          this.toggleUpdateModal();
        } else {
          this.loadClipboards();
          this.toogleCancelModal();
          history.push('/trade/admin/pranchetas');
        }
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar modificar o status');
        this.toggleUpdateModal();
      });
  };

  changeTab = ({ index }) => {
    const { match, history } = this.props;
    const route = index === 0 ? 'detalhe' : 'informacoes';
    history.push(`${match.url}/${route}`);
  };

  nameButtonStatus = status => {
    if (status === PENDENTE.id) {
      return PREPARACAO.value;
    }
    if (status === PREPARACAO.id) {
      return PRONTAENTREGA.value;
    }
    if (status === PRONTAENTREGA.id) {
      return ENTREGUE.value;
    }
    if (status === ENTREGUE.id) {
      return DEVOLVIDO.value;
    }
    return false;
  };


  labelModalConfirmation = status => {
    if (status === PENDENTE.id) {
      return PENDENTE.value;
    }
    if (status === PREPARACAO.id) {
      return PREPARACAO.value;
    }
    if (status === PRONTAENTREGA.id) {
      return PRONTAENTREGA.value;
    }
    if (status === ENTREGUE.id) {
      return ENTREGUE.value;
    }
    return false;
  };

  buttonRenderRight(statusIndex) {
    const { data, nivel } = this.state;

    return (
      <div>
        {nivel === 10 && statusIndex <= 1 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              onClick={this.toogleCancelModal}
              type="submit"
            >
              Cancelar Pedido
            </button>
          )}
        {nivel === 10 && statusIndex <= 3 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              onClick={this.toggleUpdateModal}
              type="submit"
            >
              {this.nameButtonStatus(data.status.id)}
            </button>
          )}
        {data.status.id === 5 && <h3 className="text-warning">Pedido Cancelado</h3>}
      </div>
    );
  }

  render() {
    const { data, isLoading, isUpdating, openMdStatus, cancelModal } = this.state;
    const { history } = this.props;
    const orderStatus = data && data.status;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />

          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    const statusIndex = getStatusClipboardsIndex(orderStatus ? orderStatus.id : {});
    return (
      <div>
        {data && (
          <div>
            <Breadcrumb
              title={`${data.numero} - ${
                data.tipo === 'Novo' ? 'Solicitação de Kit' : 'Solicitação de Troca'
              }`}
              description={`Criada por ${data.solicitante.nome}`}
              renderRight={this.buttonRenderRight(statusIndex)}
              renderLeft={(() => (
                <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large">
              <ProgressIndicator className="v-xl-margin" currentIndex={statusIndex}>
                <ProgressStep label="Pendente" />
                <ProgressStep label="Preparação" />
                <ProgressStep label="Pronto p/ Entrega" />
                <ProgressStep label="Entregue" />
                <ProgressStep label="Devolvido" />
              </ProgressIndicator>

              <Detail data={data} />

              <Modal
                open={openMdStatus}
                onRequestSubmit={this.updateOrderStatus}
                onRequestClose={this.toggleUpdateModal}
                modalHeading="Modificar Status"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div>
                  <p>
                    Você tem certeza que deseja alterar o status do pedido
                    {' '}
                    <strong> 
                      {' '}
                      {data.numero}
                      
                    </strong>
                    {' de '}
                    <strong>
                      {`${this.labelModalConfirmation(data.status.id)} `}
                    </strong>
                    para
                    {' '}
                    <strong> 
                      {' '}
                      {this.nameButtonStatus(data.status.id)}
                      {' '}
                    </strong>
                    ?
                  </p>
                </div>
              </Modal>

              <Modal
                open={cancelModal}
                onRequestSubmit={this.cancelRequest}
                onRequestClose={this.toogleCancelModal}
                modalHeading="Cancelar Pedido"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div className="warning-modal-txt">
                  <p>Você tem certeza que deseja cancelar este pedido?</p>
                </div>
              </Modal>
              {isUpdating && <Loading small />}
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Clipboards/Detail/Main.js